import React from 'react';
import PropTypes from 'prop-types';
import Chip from 'material-ui/Chip';

const styles = {
    chip: {
        margin: 4,
    },
    wrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        maxWidth: 500
    },
};

const SelectArrayField = React.forwardRef(({ source, record = {} }) => {
    return (
        <div style={styles.wrapper}>
            {record[source].map((item, index) => {
                return <Chip key={index}
                    style={styles.chip}
                >
                    {item}
                </Chip>
            })}
        </div>
    )
})

SelectArrayField.propTypes = {
    addLabel: PropTypes.bool,
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

SelectArrayField.defaultProps = {
    addLabel: true,
};

export default SelectArrayField;


// WEBPACK FOOTER //
// ./src/components/SelectArrayField.js